'use strict';

/** @type {import('./pow')} */
module.exports = Math.pow;



//////////////////
// WEBPACK FOOTER
// ./~/_math-intrinsics@1.1.0@math-intrinsics/pow.js
// module id = 1602
// module chunks = 0